// @ts-nocheck
import { del, get, patch, post } from "@insite/client-framework/Services/ApiService";

const customerPoEndpoint = "/api/v1/customerponumber/";

export interface CustomerPoNumber {
    uri: string;
    id: string;
    customerId: string;
    startDate: Date;
    endDate: Date | null;
    poNumber: string;
    properties: { [key: string]: string };
}

export type NewPoNumber = Omit<CustomerPoNumber, "id">;
export interface CustomerPoNumberCollection {
    uri: string;
    customerPoNumbers: CustomerPoNumberReturn[];
    properties: { [key: string]: string };
}
export interface CustomerPoNumberReturn {
    uri: string;
    id: string;
    customerId: string;
    startDate: string;
    endDate: string | null;
    poNumber: string;
    properties: { [key: string]: string };
}
const convertFromDateCustomerPoNumber = (customerPoNumber: CustomerPoNumber | NewPoNumber) => {
    return {
        ...customerPoNumber,
        startDate: customerPoNumber.startDate.toISOString(),
        endDate: customerPoNumber.endDate ? customerPoNumber.endDate.toISOString() : null,
    };
};

const convertToDateCustomerPoNumber = (customerPoNumber: CustomerPoNumberReturn): CustomerPoNumber => {
    return {
        ...customerPoNumber,
        startDate: new Date(customerPoNumber.startDate),
        endDate: customerPoNumber.endDate ? new Date(customerPoNumber.endDate) : null,
    };
};
export const getCustomerPoNumberById = async (customerId: string) => {
    return convertToDateCustomerPoNumber(await get<CustomerPoNumberReturn>(`${customerPoEndpoint}${customerId}`));
};

export const getCustomerPoNumberByCustomerID = async (customerPoNumberID: string) => {
    const collection = await get<CustomerPoNumberCollection>(`${customerPoEndpoint}bycustomerid/${customerPoNumberID}`);
    return collection.customerPoNumbers.map(convertToDateCustomerPoNumber);
};

export const createCustomerPoNumber = async (params: Omit<CustomerPoNumber, "id">) => {
    const customerPoNumber = convertFromDateCustomerPoNumber(params);

    const apiReturn = await post<Omit<CustomerPoNumberReturn, "id">, CustomerPoNumberReturn>(
        customerPoEndpoint,
        customerPoNumber,
    );
    const convertedReturn = convertToDateCustomerPoNumber(apiReturn);
    return convertedReturn;
};

export const updateCustomerPoNumber = async (params: CustomerPoNumber) => {
    const { id } = params;
    return convertToDateCustomerPoNumber(
        await patch<CustomerPoNumberReturn>(`${customerPoEndpoint}${id}`, convertFromDateCustomerPoNumber(params)),
    );
};

export const deleteCustomerPoNumber = (customerPoNumberID: string) => {
    return del(`${customerPoEndpoint}${customerPoNumberID}`);
};
